/**
 * An error that occurred during execution.
 */
export class ExecutionError extends Error {
}

/**
 * An error that occurred during execution and is related to the execution helper.
 */
export class ExceutionHelperError extends Error {
  constructor(message: string, name: string, stack?: string) {
    super(message);
    this.name = name;
    if (stack) {
      this.stack = stack;
    }
  }
}
